<div *ngFor="let product of currentProducts" class="sbw_agent_product">
    <div class="row">
        <div class="small-12 medium-7 column"><span class="sbw_agent_product_description">{{product.description}}</span></div>
        <div class="small-12 medium-5 column quarter-gutter">
            <a class="default-action sbw_agent_productlist_link" (click)="onClick(product.code)">{{product.code}}<span class="arrow-white-left"></span>
            </a>
        </div>
    </div>
</div>